import { registerErrorsSideEffect } from './errors'

export function sideEffect() {
  registerErrorsSideEffect()
}
